import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ResourceStore } from 'src/app/stores/resources/resource.store';
import { FormBuilder, FormGroup, AbstractControl, Validators } from '@angular/forms';
import { TABS } from 'src/app/dummy/tab';
import { MatDialog, MatSnackBar } from '@angular/material';
import { ActivityStore } from 'src/app/stores/resources/activity.store';
import { Location } from '@angular/common';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { ConvertService, removeObjArray, pushObjArray } from 'src/app/services/convert.service';
import { STATUS_OBJECT, DISPLAY_STATUS_OBJECT, SKILL_OBJECT } from 'src/app/dummy/status';
import { IActivity } from 'src/app/interfaces/resource';
import { DataService } from 'src/app/services/data.service';
import { COLLECTION_NAME, FILE_FOLDER } from 'src/app/dummy/app';
import { FireStorageService } from 'src/app/services/fire-storage.service';
import { getYoutubeId } from 'src/app/services/mapping.service';
import { AddMultipleChoiceQuestionAnswerComponent } from '../multiple-choice-question/add-multiple-choice-question-answer/add-multiple-choice-question-answer.component';
import { AddMultipleChoiceComponent } from '../multiple-choice-question/add-multiple-choice/add-multiple-choice.component';

@Component({
  selector: 'app-interesting-article',
  templateUrl: './interesting-article.component.html',
  styleUrls: ['./interesting-article.component.scss']
})
export class InterestingArticleComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  @ViewChild('bookFile', {static:false}) bookFile: ElementRef;
  @ViewChild('coverFile', {static:false}) coverFile: ElementRef;
  @ViewChild('audioFile', {static:false}) audioFile: ElementRef;

  tabs = TABS.INTERESTING_ARTICLE;
  TITLE = "Modules"
  ITEM: any;
  ITEM_KEY: any;
  MODULE_KEY: any;
  MODULE: any;

  form: FormGroup;


  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  SKILL = 'reading';
  SKILL_NAME = 'Reading';
  ACTIVITY_TYPE = 'interesting_article'
  ACTIVITY_LIST: any[] = [];
  ACTIVITY_TYPE_LIST: any[];
  ACTIVITY_TYPE_OBJECT: any = {};
  YOUTUBE_ID: any;
  START_UPLOAD: any;

  SELECTED_BOOK_FILE: any;
  SELECTED_COVER_FILE: any;
  SELECTED_AUDIO_FILE: any[] = [];

  uploadPercent: any;

  constructor(private router: Router
    , private route: ActivatedRoute
    , public resource: ResourceStore
    , private fb: FormBuilder
    , private dialog: MatDialog
    , public store: ActivityStore
    , private auth: AuthStore
    , private ds: DataService
    , private snackBar: MatSnackBar
    , private storage: FireStorageService
  ) { }

  goBack() {
    if (this.processClose || this.processNew) return;
    this.router.navigate([`/modules/submitted/${this.MODULE.lessonKey}/lesson`])
  }

  uploadFileAudio(event) {
    if (event && event.target.files.length > 0) {
      this.SELECTED_AUDIO_FILE = []
      for (let index = 0; index < event.target.files.length; index++) {
        const element = event.target.files[index];
        this.SELECTED_AUDIO_FILE.push(element);
      }
      this.audioFile.nativeElement.value = "";
    }
  }

  uploadFileSound(event) {
    if (event && event.target.files.length > 0) {
      this.SELECTED_BOOK_FILE = event.target.files[0];
      this.bookFile.nativeElement.value = "";
    }
  }

  uploadFileCover(event) {
    if (event && event.target.files.length > 0) {
      this.SELECTED_COVER_FILE = event.target.files[0];
      this.coverFile.nativeElement.value = "";
    }
  }

  youtubeControl(control: AbstractControl) {
    if (control) {
      const { value } = control;
      this.YOUTUBE_ID = value ? getYoutubeId(value) : null;
    }
  }

  async ngOnInit() {
    this.form = this.fb.group({
      youtube: [null, Validators.compose([this.youtubeControl.bind(this)])],
      name: [null],
      instruction: [null],
      defaultInstruction: [true],
    })
    await this.auth.fetchUser()
    this.route.params.subscribe(async params => {
      const { id, MODULE_KEY } = params;
      this.ITEM_KEY = id;
      this.MODULE_KEY = MODULE_KEY
      this.tabs = TABS.INTERESTING_ARTICLE.filter(m => m.key === this.SKILL).map(m => ({ path: `${m.path}/${MODULE_KEY}/${m.key === SKILL_OBJECT.READING.key ? id : 'draft'}`, label: m.label, key: m.key }))
      this.ACTIVITY_TYPE_LIST = await this.store.fetchActivityType()
      this.ACTIVITY_TYPE_OBJECT = this.ACTIVITY_TYPE_LIST.filter(m => m.key === this.ACTIVITY_TYPE)[0];
      this.MODULE = await this.store.fetchModule(this.MODULE_KEY)
      if (!this.MODULE) {
        this.router.navigate(['/404']);
        return;
      }
      if (id !== 'draft') {
        this.store.fetchActivity(id, doc => {
          this.ITEM = doc;
          if (!doc) {
            this.goBack()
            return;
          }
          const { youtube, instruction, defaultInstruction, name } = doc;
          this.form.patchValue({ youtube: youtube, instruction, defaultInstruction, name: name })
          this.inputEl.nativeElement.focus();
        })
      }
      else {
        this.ITEM = null;
        this.ITEM_KEY = null;
        this.form.patchValue({ youtubeId: null, instruction: null, defaultInstruction: true, name: null })
        setTimeout(() => {
          this.inputEl.nativeElement.focus();
        }, 100);
      }
    })

  }

  onDeleteBookFile(field) {
    const { ebookFile } = this.ITEM
    const dialogRef = this.dialog.open(DeleteComponent, {
      data: { button: 'delete', name: ebookFile.name, title: 'Delete File' },
      panelClass: 'cs-overlay-panel',
      width: '35vw',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.store.updateBook(this.ITEM.key, field, null, res => {
          this.snackBar.open("File has been removed successful.", "Done", { duration: 1000 });
        })
      }
    })
  }

  onDeleteAudioFile(file) {
    const dialogRef = this.dialog.open(DeleteComponent, {
      data: { button: 'delete', name: file.name, title: 'Delete File' },
      panelClass: 'cs-overlay-panel',
      width: '35vw',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        const { ebookAudioFiles } = this.ITEM
        const files = ebookAudioFiles.filter(m => m.key !== file.key);
        this.store.updateBook(this.ITEM.key, 'ebookAudioFiles', files, res => {
          this.snackBar.open("File has been removed successful.", "Done", { duration: 1000 });
        })
      }
    })
  }

  ngOnDestroy(): void {
    const { fetchActivityRef } = this.store;
    fetchActivityRef && fetchActivityRef.unsubscribe();
  }


  async onSave(f: any, isBack: boolean) {
    if (this.form.valid) {
      this.processClose = isBack ? true : false;
      this.processNew = !isBack;
      this.form.disable();
      const { youtube, instruction, defaultInstruction, name } = f;
      const { user, selectedCompanyKey } = this.auth;
      const youtubeId = getYoutubeId(youtube) || null;
      const registerStatus = STATUS_OBJECT.submitted;
      const key = this.ITEM ? this.ITEM.key : this.ds.createId();
      const activity: IActivity = {
        key: key,
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: this.ITEM ? this.ITEM.created_at : new Date(),
        created_by: this.ITEM ? this.ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: this.ITEM ? this.ITEM.date_key : ConvertService.dateKey(),
        page_key: ConvertService.pageKey(),
        keyword: null,
        organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
        organizationKey: selectedCompanyKey,
        created_byRef: this.ITEM ? this.ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        //fields
        name: name || null,
        instruction: instruction || null,
        defaultInstruction: defaultInstruction || false,
        youtubeId: youtubeId || null,
        youtube: youtube || null,
        hasSubActivity: false,
        //module
        skillKey: this.ITEM ? this.ITEM.skillKey : this.SKILL,
        skillRef: this.ds.skillRef().doc(this.SKILL).ref,
        skillName: this.SKILL_NAME,
        activityTypeKey: this.ACTIVITY_TYPE,
        activityTypeRef: this.ds.activityTypeRef().doc(this.ACTIVITY_TYPE).ref,
        activityTypeName: this.ACTIVITY_TYPE_OBJECT.name,
        moduleKey: this.MODULE_KEY,
        moduleRef: this.ds.firestoreRef().collection(COLLECTION_NAME.MODULE).doc(this.MODULE_KEY).ref,
        questions: this.ITEM ? this.ITEM.questions || [] : [],
      }
      if (this.SELECTED_BOOK_FILE) {
        this.START_UPLOAD = true;
        const file = this.SELECTED_BOOK_FILE;
        const fileName = file.name;
        const uploadPath = `${FILE_FOLDER.TRAINING_RESOURCES}/${this.ds.createId()}_${fileName}`;
        const uploadTask = this.storage.uploadSelectedFile(file, uploadPath);
        this.uploadPercent = uploadTask.percentageChanges();
        const files = await this.storage.getFileDetail(file, uploadPath, uploadTask)
        activity.ebookFile = files;
        this.SELECTED_BOOK_FILE = null;
        this.START_UPLOAD = false;
      }
      if (this.SELECTED_COVER_FILE) {
        this.START_UPLOAD = true;
        const file = this.SELECTED_COVER_FILE;
        const fileName = file.name;
        const uploadPath = `${FILE_FOLDER.TRAINING_RESOURCES}/${this.ds.createId()}_${fileName}`;
        const uploadTask = this.storage.uploadSelectedFile(file, uploadPath);
        this.uploadPercent = uploadTask.percentageChanges();
        const files = await this.storage.getFileDetail(file, uploadPath, uploadTask)
        activity.ebookCoverFile = files;
        this.SELECTED_COVER_FILE = null;
        this.START_UPLOAD = false;
      }

      if (this.SELECTED_AUDIO_FILE && this.SELECTED_AUDIO_FILE.length > 0) {
        const audioFiles: any[] = [];
        for (let index = 0; index < this.SELECTED_AUDIO_FILE.length; index++) {
          const element = this.SELECTED_AUDIO_FILE[index];
          this.START_UPLOAD = true;
          const file = element;
          const fileName = file.name;
          const uploadPath = `${FILE_FOLDER.TRAINING_RESOURCES}/${this.ds.createId()}_${fileName}`;
          const uploadTask = this.storage.uploadSelectedFile(file, uploadPath);
          this.uploadPercent = uploadTask.percentageChanges();
          const files = await this.storage.getFileDetail(file, uploadPath, uploadTask)
          audioFiles.push({ ...files, key: this.ds.createId() })
          this.START_UPLOAD = false;
        }
        activity.ebookAudioFiles = audioFiles;
        this.SELECTED_AUDIO_FILE = [];
      }

      this.store.addItem(activity, this.MODULE, this.ITEM ? true : false, (success, res) => {
        if (success) {
          this.snackBar.open("Activity has been saved successful.", "Done", { duration: 1000 });
          this.processClose = false;
          this.processNew = false;
          if (isBack) {
            this.goBack()
          }
          else {
            this.router.navigate([`/modules/activity-type/${this.ACTIVITY_TYPE}/${this.SKILL}/${this.MODULE_KEY}/${this.ITEM_KEY}`])
          }
          this.form.enable();
          this.inputEl.nativeElement.focus();
        }
      })

    }
  }

  delete(question) {
    const dialogRef = this.dialog.open(DeleteComponent, {
      data: { button: 'delete', name: question.name, title: 'Delete Dictation' },
      panelClass: 'cs-overlay-panel',
      width: '35vw',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.form.disable();
        const { name, instruction, defaultInstruction, youtube } = this.form.value;
        const { user, selectedCompanyKey } = this.auth;
        const { questions } = this.ITEM;
        const QUESTION_DATA = removeObjArray(questions, question.key)
        const youtubeId = getYoutubeId(youtube) || null;
        const registerStatus = STATUS_OBJECT.submitted;
        const key = this.ITEM ? this.ITEM.key : this.ds.createId();
        const activity: IActivity = {
          key: key,
          status: DISPLAY_STATUS_OBJECT.ACTIVE,
          isDelete: false,
          created_at: this.ITEM ? this.ITEM.created_at : new Date(),
          created_by: this.ITEM ? this.ITEM.created_by : user.uid,
          updated_at: new Date(),
          updated_by: user.uid,
          date_key: this.ITEM ? this.ITEM.date_key : ConvertService.dateKey(),
          page_key: ConvertService.pageKey(),
          keyword: null,
          organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
          organizationKey: selectedCompanyKey,
          created_byRef: this.ITEM ? this.ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
          updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
          register_status: registerStatus,
          //fields
          name: name,
          instruction: instruction || null,
          defaultInstruction: defaultInstruction || false,
          youtubeId: youtubeId,
          youtube: youtube,
          hasSubActivity: false,
          //module
          skillKey: this.ITEM ? this.ITEM.skillKey : this.SKILL,
          skillRef: this.ds.skillRef().doc(this.SKILL).ref,
          skillName: this.SKILL_NAME,
          activityTypeKey: this.ACTIVITY_TYPE,
          activityTypeRef: this.ds.activityTypeRef().doc(this.ACTIVITY_TYPE).ref,
          activityTypeName: this.ACTIVITY_TYPE_OBJECT.name,
          moduleKey: this.MODULE_KEY,
          moduleRef: this.ds.firestoreRef().collection(COLLECTION_NAME.MODULE).doc(this.MODULE_KEY).ref,
          questions: QUESTION_DATA,
        }
        this.store.update(activity, (success, res) => {
          this.snackBar.open("Question has been deleted successful.", "Done", { duration: 1000 });
          this.form.enable();
        })
      }
    })
  }


  addNewLine(question) {
    let dialogRef = this.dialog.open(AddMultipleChoiceComponent, {
      data: {
        FORM: this.form.value,
        ITEM: this.ITEM,
        SKILL: this.SKILL,
        ACTIVITY_TYPE: this.ACTIVITY_TYPE,
        MODULE_KEY: this.MODULE_KEY,
        QUESTION: question || null,
        ACTIVITY_TYPE_OBJECT: this.ACTIVITY_TYPE_OBJECT,
        SKILL_NAME: this.SKILL_NAME,
        MODULE: this.MODULE,
      },
      panelClass: 'item-list-panel',
      width: '',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => {
    });
  }


  createQuiz(item, question) {
    let dialogRef = this.dialog.open(AddMultipleChoiceQuestionAnswerComponent, {
      data: {
        FORM: this.form.value,
        ITEM: this.ITEM,
        SKILL: this.SKILL,
        ACTIVITY_TYPE: this.ACTIVITY_TYPE,
        MODULE_KEY: this.MODULE_KEY,
        QUESTION: item,
        ANSWER: question || null,
        ACTIVITY_TYPE_OBJECT: this.ACTIVITY_TYPE_OBJECT,
        SKILL_NAME: this.SKILL_NAME,
        MODULE: this.MODULE,
      },
      panelClass: 'item-list-panel',
      width: '',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => {
    });
  }


  deleteAnswer(question, answer) {
    const dialogRef = this.dialog.open(DeleteComponent, {
      data: { button: 'delete', name: question.name, title: 'Delete Answer' },
      panelClass: 'cs-overlay-panel',
      width: '35vw',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        const answerAfterRemove = removeObjArray(question.answers || [], answer.key);
        question.answers = answerAfterRemove;
        const { questions } = this.ITEM;
        const questionsData = pushObjArray(questions, question)
        this.ITEM.questions = questionsData;
        this.store.addItem(this.ITEM, this.MODULE, this.ITEM ? true : false, (success, res) => {
          this.snackBar.open("Answer has been removed successful.", "Done", { duration: 1000 });
        })
      }
    })
  }





}
